import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import PublicPagesNav from './PublicPagesNav';

const PublicHeader = ({ name, weddingDate, hashtag, location, slug, pages }) => (
  <header id="public-page-header" className="clearfix">
    <div className="top-row hidden-xs hidden-sm">
      {weddingDate && (
        <h5 className="wedding-date">
          {weddingDate}
        </h5>
      )}
      {location && (
        <h5 className="wedding-location">
          {location}
        </h5>
      )}
      {hashtag && (
        <h5 className="hashtag">
          #{hashtag}
        </h5>
      )}
    </div>
    <div className="col-xs-12 website-title">
      <h1>
        <Link to={`/wedding/${slug}`}>
          {name}
        </Link>
      </h1>
      <PublicPagesNav pages={pages} slug={slug} />
    </div>
  </header>
);

PublicHeader.propTypes = {
  name: PropTypes.string.isRequired,
  weddingDate: PropTypes.string,
  hashtag: PropTypes.string,
  location: PropTypes.string,
  slug: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PublicHeader;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/PublicHeader.jsx
 **/